import "@/App.css";
import "@/styles/landing.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/components/LandingPage";
import LandingPageInversion from "@/components/LandingPageInversion";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/inversion" element={<LandingPageInversion />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
